import React, { useState } from "react";
import axios from "axios";
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import './MessageUs.css';
import { GrFormSubtract } from "react-icons/gr";
import { API_URL } from '../../config';

export default function MessageUs() {
  const [isOpen, setIsOpen] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", mobile: "", purpose: "", message: "" });
  const [resmessage , setResMessage] = useState("")


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.name ||
      !form.email ||
      !form.mobile ||
      !form.purpose ||
      !form.message
  ) {
      alert("Please fill in all the required fields.");
      return false;
  }

    const token = "jgkjdjfjtuerhi43jsfd"

    const formData = new FormData();
    formData.append('Token', token);
    formData.append('name', form.name);
    formData.append('email', form.email);
    formData.append('mobile', form.mobile);
    formData.append('purpose', form.purpose);
    formData.append('message', form.message);

    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }


    try {
      const response = await axios.post(`${API_URL}/contact_form.php`, formData , {withCredentials:false});
      setForm({ name: "", email: "", mobile: "", purpose: "", message: "" });
      setResMessage("Thank you for your message! We will get back to you soon.")
      setTimeout(() => setResMessage("") , 5000)
      // alert("Thank you for your message! We will get back to you soon.")
      console.log(response.data);
    } catch (err) {
      setResMessage("There was an error submitting your message. Please try again later.");
      console.log("Error", err.response ? err.response.data : err.message);
    }
  };

  const handleVerifyRecaptcha = (token) => {
    if (token) {
      setIsVerified(true);
    }
  };

  return (
    <div className="message__container">
      <div className="message__heading">
        <p>MESSAGE US</p>
        <p>Fill in the information required in the form and we will get back to you soon.</p>
        <p>Your information will be kept private and confidential and will be used by Graviti only. All details provided by you will be held by Graviti and used in accordance with our Privacy Policy.</p>
      </div>
      <div className="message__form">
        <form onSubmit={handleSubmit}>
          <div className="message__form_line1">
            <div className="inputbox__container">
              <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
              <input type="text" name="name" value={form.name} placeholder={'Enter Full name...'}
                onChange={(e) => {
                  const trimmedValue = e.target.value.trim();
                  setForm({ ...form, name: trimmedValue }); 
                }}
                required />
            </div>
            <div className="inputbox__container">
              <label htmlFor="number">Mobile <span style={{ color: "red" }}>*</span></label>
              <input type="text" name="number" value={form.mobile} placeholder={'Enter number...'}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^[0-9]*$/.test(inputValue) && inputValue.length < 11) {
                    setForm({ ...form, mobile: inputValue });
                  }
                }} required />
            </div>
          </div>

          <div className="message__form_line1">
            <div className="inputbox__container">
              <label htmlFor="email">Email <span style={{ color: "red" }}>*</span></label>
              <input type="email" name="email" value={form.email} placeholder={'Enter Email Address...'} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div className="inputbox__container">
              <p>Purpose <span style={{ color: "red" }}>*</span></p>
              <div className={`dropdown__box ${isOpen ? "open" : ""}`}
                onMouseEnter={() => setIsOpen(true)}
                onClick={() => setIsOpen((prev) => !prev)}
                tabIndex={0}
                onBlur={() => setIsOpen(false)}>
                <div className="dropdown__Selected_Date">
                  {form.purpose}
                  <div className="dropdown__icons">
                    <span><GrFormSubtract /></span>
                    <span style={{ left: "8px" }}><GrFormSubtract /></span>
                  </div>
                </div>
                {isOpen && (
                  <div className="dropdown__options__box">
                    <h5 onClick={() => { setForm({ ...form, purpose: "Enquiry" }); setIsOpen(false); }}>Enquiry</h5>
                    <h5 onClick={() => { setForm({ ...form, purpose: "Support" }); setIsOpen(false); }}>Support</h5>
                    <h5 onClick={() => { setForm({ ...form, purpose: "Partner with us" }); setIsOpen(false); }}>Partner with us</h5>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="message__form_line1">
            <div className="inputbox__container">
              <label htmlFor="message">Message <span style={{ color: "red" }}>*</span></label>
              <input type="text" name="message" value={form.message} placeholder={'Enter your message...'}
                onChange={(e) => {
                  setForm({ ...form, message: e.target.value });
                }} required
              />
            </div>
          </div>
          <GoogleReCaptcha
            sitekey="6LeYZ0wpAAAAAEYgLXhzix1Q2aPN6LrY4tHygysu"
            onVerify={handleVerifyRecaptcha}
          />

          {resmessage && <div className="res-message">{resmessage}</div>}
          {/* <div className="res-message">Thank you for your message! We will get back to you soon.</div> */}
          
          <div className="message__button">
            <button type="submit">SEND</button>
          </div>
        </form>
      </div>
    </div>
  );
}